/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterDeleteOrg } from "../../funcs/authClusterDeleteOrg.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteClusterOrgRequest$inboundSchema,
};

export const tool$authClusterDeleteOrg: ToolDefinition<typeof args> = {
  name: "auth-cluster-delete-org",
  description: `Soft-delete an organization`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterDeleteOrg(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
